import React from 'react';
import { faCheck, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './DiaryTaskIcon.module.css';
import { CommonButton } from '_components';


export class DiaryTaskIcon extends React.Component {
    render() {
        let cls;

        switch (this.props.status) {
            case 1:
                cls = styles.green;
                if (this.props.className ) {
                    cls += ' ' + this.props.className;
                }
                return (
                    <CommonButton title={this.props.title ? this.props.title : 'Open 0 to 3 days'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                    </CommonButton>
                );
            case 2:
                cls = styles.orange;
                if (this.props.className ) {
                    cls += ' ' + this.props.className;
                }
                        return (
                    <CommonButton title={this.props.title ? this.props.title : 'Open 4 to 7 days'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                    </CommonButton>
                );
            case 3:
                cls = styles.red;
                if (this.props.className ) {
                    cls += ' ' + this.props.className;
                }
                        return (
                    <CommonButton title={this.props.title ? this.props.title : 'Open more than 7 days'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                        <FontAwesomeIcon icon={faArrowRight} transform="shrink-6" color="white" />
                    </CommonButton>
                );
            case 4:
                cls = styles.checkmark;
                if (this.props.className ) {
                    cls += ' ' + this.props.className;
                }
                        return (
                    <CommonButton title={this.props.title ? this.props.title : 'Resolved'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                        <FontAwesomeIcon icon={faCheck} color="#99cc00" />
                    </CommonButton>
                );
            default:
                return (<span></span>);
        }
    }
}

